<template>
    <div id="ticket-bundle-container"
        class="ticket-bundle"
    >
        <i class="ticket-bundle__icon icon-bundle-ticket" />
        <span id="ticket-bundle-badge"
            class="token-participation-amount__text"
        >
            {{ `${quantity} ${$t('rewards.fanShop.productDetails.tickets')}` }}
        </span>
    </div>
</template>

<script>
export default {
    name: 'ticket-bundle-hud',
    props: {
        quantity: {
            type: Number,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.ticket-bundle {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    font-weight: 700;
    background-color: $white-color;
    border: 1px solid $daintree-color;
    border-radius: 10rem;
    padding: 0 10px;
    color: $daintree-color;

    &__icon {
        font-size: 2rem;
    }

    span {
        margin-left: 0.64rem;
    }
}
</style>